export { default as SzgcFormGetor } from "./package/SzgcFormGetor/index.vue";

export { install_kinggrid } from "./kinggrid";

export { ntko_addon } from "./ntko";

export { default as NtkoSign } from "./ntko/NtkoSign.vue";

export { default as ContractLock } from "./ContractLock";

window.SignatureEnable = false;

